import { parseHTMLStringToFragment, serializeFragmentToHTMLString } from 'proseShared/utils'
import { Schema } from 'prosemirror-model'
import { defaultMarkdownParser, defaultMarkdownSerializer } from 'prosemirror-markdown'

export const convertMarkdownToHtml = (markdown: string, schema: Schema): string => {
  try {
    const doc = defaultMarkdownParser.parse(markdown)
    if (!doc) throw new Error('Failed to parse markdown')
    return serializeFragmentToHTMLString(doc.content, schema)
  } catch (error) {
    return `<p>${markdown.replace(/\n/g, '<br>')}</p>`
  }
}

export const convertHtmlToMarkdown = (html: string, schema: Schema): string => {
  try {
    const doc = schema.nodes.doc.create({}, parseHTMLStringToFragment(html, schema))
    return defaultMarkdownSerializer.serialize(doc)
  } catch (error) {
    return html
      .replace(/<[^>]*>/g, '')
      .replace(/\s+/g, ' ')
      .trim()
  }
}

export interface ProfileSection {
  title: string
  content: string
}

export const parseProfileSections = (markdown: string): ProfileSection[] => {
  return markdown.split('\n').reduce<ProfileSection[]>((sections, line) => {
    if (line.startsWith('## ')) {
      sections.push({ title: line.replace('## ', ''), content: '' })
    } else if (sections.length > 0) {
      const lastSection = sections[sections.length - 1]
      lastSection.content += (lastSection.content ? '\n' : '') + line
    }
    return sections
  }, [])
}

const sanitizeSectionContent = (content: string): string => content.replace(/^##(?=\s)/gm, '\\##')

export const reconstructMarkdown = (sections: ProfileSection[]): string => {
  return sections
    .map((section) => {
      const sanitizedContent = sanitizeSectionContent(section.content)
      return `## ${section.title}\n${sanitizedContent}`
    })
    .join('\n\n')
}
